import { httpClient } from './config';

export const recoverPasswordSearchForUsers = async ({
  cpf,
}: any) => httpClient.post<any, string>('/api/patient', { cpf });

export const recoverPasswordMailRequest = async ({
  prontuarioId,
}: any) => httpClient.put<any, string>('/api/patient', { prontuarioId });
